import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Home.css";
import hero1 from "../../../assets/images/hero1.png";
import h1 from "../../../assets/images/h1.png";
import hero2 from "../../../assets/images/hero2.png";
import h2 from "../../../assets/images/h2.png";

import { FaTruck, FaShieldAlt, FaHeadset, FaGlobe, FaLock, FaAws } from "react-icons/fa";
import { BACKEND_URL } from "../../../config";



const heroSlides = [
  { desktop: hero1, mobile: h1, route: "/categories/sildenafil-citrate" },
  { desktop: hero2, mobile: h2, route: "/categories/vardenafil" },
 
];


function Home() {
  const [products, setProducts] = useState([]);
  const [activeFAQ, setActiveFAQ] = useState(0);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const movedX = useRef(0);
  const autoplayRef = useRef(null);

  // ===== Refs for product scroller sections =====
  const bestsellerRef = useRef(null);
  const newLaunchRef = useRef(null);
  const mostSearchedRef = useRef(null);

  const scrollByAmount = (ref, amount) => {
    if (ref.current) {
      ref.current.scrollBy({ left: amount, behavior: "smooth" });
    }
  };

  const goToSlide = (index) => {
    setCurrentSlide((index + heroSlides.length) % heroSlides.length);
  };

  const resetAutoplay = () => {
    clearInterval(autoplayRef.current);
    autoplayRef.current = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % heroSlides.length);
    }, 4000);
  };

  const handleMouseDown = (e) => {
    isDragging.current = false;
    startX.current = e.clientX;
    movedX.current = 0;
  };
  const handleMouseMove = (e) => {
    movedX.current = e.clientX - startX.current;
    if (Math.abs(movedX.current) > 5) isDragging.current = true;
  };
  const handleMouseUp = () => {
    if (movedX.current < -60) goToSlide(currentSlide + 1);
    else if (movedX.current > 60) goToSlide(currentSlide - 1);
    setTimeout(() => { isDragging.current = false; }, 0);
    resetAutoplay();
  };

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
    movedX.current = 0;
    isDragging.current = false;
  };
  const handleTouchMove = (e) => {
    movedX.current = e.touches[0].clientX - startX.current;
  };
  const handleTouchEnd = () => {
    if (movedX.current < -60) goToSlide(currentSlide + 1);
    else if (movedX.current > 60) goToSlide(currentSlide - 1);
    setTimeout(() => { isDragging.current = false; }, 0);
    resetAutoplay();
  };

    const toSlug = (str = "") =>
    str.toLowerCase().trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

    useEffect(() => {
      fetch(`${BACKEND_URL}/api.php?module=product`)
        .then(res => res.json())
        .then(data => { if (data.success) setProducts(data.data); else setProducts([]); })
        .catch(err => console.log(err));

      fetch(`${BACKEND_URL}/api.php?module=blog`)
        .then(res => res.json())
        .then(data => { if (data.success) setBlogs(data.data); else setBlogs([]); })
        .catch(err => console.log(err));

      fetch(`${BACKEND_URL}/api.php?module=category`)
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setCategories(data.data);
          }
        })
        .catch((err) => console.log(err));
    }, []);

    useEffect(() => {
    resetAutoplay();
    return () => clearInterval(autoplayRef.current);
  }, []);

    const safeJSON = (data) => {
      if (!data) return [];
      if (typeof data === "string") { try { return JSON.parse(data); } catch { return []; } }
      return data;
    };

    const bestsellerProducts = products.filter(
      (item) => item.section === "bestseller"
    );

    const newLaunchProducts = products.filter(
      (item) => item.section === "new-launch"
    );

    const mostSearchedProducts = products.filter(
      (item) => item.section === "most-searched"
    );

    const handleSubscribe = async (e) => {
      e.preventDefault();
      try {
        const res = await fetch(`${BACKEND_URL}/api.php?module=newsletter`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email })
        });
        const data = await res.json();
        alert(data.message);
        if (data.success) setEmail("");
      } catch (err) {
        alert("Something went wrong");
      }
    };

    const ProductCard = ({ item }) => {
      const price = safeJSON(item.packPricing)?.[0]?.price || "N/A";
      return (
        <div className="product-card">
          <img
            src={item.image?.startsWith("http") ? item.image : `${BACKEND_URL}/${item.image}`}
            alt={item.productName}
            onClick={() => navigate(`/product/${item.slug}`)}
          />
          <h3 onClick={() => navigate(`/product/${item.slug}`)}>{item.productName}</h3>
        
          <p className="product-price">Starting at just <span>€{price}</span></p>
          <button className="btn" onClick={() => navigate(`/product/${item.slug}`)}>View Product</button>
        </div>
      );
    };

  return (
    <>
      <Helmet>
        <title>Realgenericshop | Online Pharmacy</title>
        <meta name="description" content="Buy medicines online with fast delivery" />
        <meta name="keywords" content="online pharmacy, medicines, healthcare" />
         <link rel="canonical" href="https://realgenericshop.com/" />
      </Helmet>
       
      <div className="home">

       
        {/* ===== HERO SLIDER ===== */}
        <div className="hero-slider-wrapper">
          <section className="hero-slider" ref={sliderRef}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <div
              className="slides-track"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {heroSlides.map((slide, i) => (
                <div className="hero-slide" key={i} onClick={() => !isDragging.current && navigate(slide.route)}>
                  <picture>
                    <source media="(max-width: 768px)" srcSet={slide.mobile} />
                    <img src={slide.desktop} className="hero-img" alt="hero banner" />
                  </picture>
                </div>
              ))}
            </div>
          </section>

          {/* DOTS — slider ke BAHAR, neeche */}
          {heroSlides.length > 1 && (
            <div className="carousel-indicators">
              {heroSlides.map((_, index) => (
                <button
                  key={index}
                  className={currentSlide === index ? "active" : ""}
                  onClick={() => { goToSlide(index); resetAutoplay(); }}
                />
              ))}
            </div>
          )}
        </div>

        {/* ===== CATEGORIES ===== */}
        <section className="shop-categories-section container">
          <h2 className="section-title">Popular Categories</h2>
          <div className="categories-marquee-wrapper">
            <div className="categories-marquee-track">
              {[...categories, ...categories].map((cat, index) => (
                <div
                  className="shop-category-item"
                  key={index}
                  onClick={() => navigate(`/categories/${cat.slug}`)}
                >
                  <div className="shop-category-icon">
                    <img
                      src={
                        cat.image?.startsWith("http")
                          ? cat.image
                          : `${BACKEND_URL}/${cat.image}`
                      }
                      alt={cat.categoryName}
                    />
                  </div>
                  <p>{cat.categoryName}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== FEATURES ===== */}
        <section className="features">
          <h2 className="section-title">Your Trust, Our Priority</h2>
          <div className="container feature-row">
            <div className="feature-item" onClick={() => navigate("/delivery")}>
              <FaTruck className="feature-icon" /><span>Fast & Secure Delivery</span>
            </div>
            <div className="feature-item" onClick={() => navigate("/security")}>
              <FaShieldAlt className="feature-icon" /><span>Secured With McAfee</span>
            </div>
            <div className="feature-item" onClick={() => navigate("/support")}>
              <FaHeadset className="feature-icon" /><span>24/7 Service</span>
            </div>
            <div className="feature-item" onClick={() => navigate("/worldwide")}>
              <FaGlobe className="feature-icon" /><span>Worldwide Shipping</span>
            </div>
            <div className="feature-item" onClick={() => navigate("/aws-security")}>
              <FaAws className="feature-icon" /><span>Data Secured With AWS</span>
            </div>
            <div className="feature-item" onClick={() => navigate("/ssl")}>
              <FaLock className="feature-icon" /><span>SSL Certified</span>
            </div>
          </div>
        </section>

        {/* ===== BESTSELLERS ===== */}
        <section className="bestseller-section container">
          <h2 className="section-title">Bestsellers</h2>
          <div className="slider-wrapper">
            <button
              className="scroll-arrow scroll-arrow-left"
              onClick={() => scrollByAmount(bestsellerRef, -260)}
              aria-label="Scroll left"
              type="button"
            >
              ‹
            </button>
            <div className="product-list horizontal" ref={bestsellerRef}>
              {bestsellerProducts.map(item => (
                <ProductCard key={item.id} item={item} />
              ))}
            </div>
            <button
              className="scroll-arrow scroll-arrow-right"
              onClick={() => scrollByAmount(bestsellerRef, 260)}
              aria-label="Scroll right"
              type="button"
            >
              ›
            </button>
          </div>
        </section>

        {/* ===== NEW LAUNCH ===== */}
        <section className="bestseller-section container">
          <h2 className="section-title">New Launch</h2>
          <div className="slider-wrapper">
            <button
              className="scroll-arrow scroll-arrow-left"
              onClick={() => scrollByAmount(newLaunchRef, -260)}
              aria-label="Scroll left"
              type="button"
            >
              ‹
            </button>
            <div className="product-list horizontal" ref={newLaunchRef}>
              {newLaunchProducts.map(item => (
                <ProductCard key={item.id} item={item} />
              ))}
            </div>
            <button
              className="scroll-arrow scroll-arrow-right"
              onClick={() => scrollByAmount(newLaunchRef, 260)}
              aria-label="Scroll right"
              type="button"
            >
              ›
            </button>
          </div>
        </section>

        {/* ===== MOST SEARCHED ===== */}
        <section className="bestseller-section container">
          <h2 className="section-title">Most Searched</h2>
          <div className="slider-wrapper">
            <button
              className="scroll-arrow scroll-arrow-left"
              onClick={() => scrollByAmount(mostSearchedRef, -260)}
              aria-label="Scroll left"
              type="button"
            >
              ‹
            </button>
            <div className="product-list horizontal" ref={mostSearchedRef}>
              {mostSearchedProducts.map(item => (
                <ProductCard key={item.id} item={item} />
              ))}
            </div>
            <button
              className="scroll-arrow scroll-arrow-right"
              onClick={() => scrollByAmount(mostSearchedRef, 260)}
              aria-label="Scroll right"
              type="button"
            >
              ›
            </button>
          </div>
        </section>

        {/* ===== BLOGS ===== */}
        <section className="blogs container">
          <h2 className="section-title">Recent Articles</h2>
          {blogs.length === 0 && <div className="no-blog">No blogs available</div>}
          <div className="home-blog-grid">
            {blogs.slice(0, 3).map(blog => (
              <div className="home-blog-card" key={blog.id}>
                <div className="home-blog-image-box" onClick={() => navigate(`/blog/${toSlug(blog.title)}`)}>
                  <img
                    src={blog.image?.startsWith("http") ? blog.image : `${BACKEND_URL}/${blog.image}`}
                    alt={blog.title}
                    className="home-blog-image"
                  />
                </div>
                <div className="home-blog-content">
                  <span className="home-blog-date">{blog.created_at ? new Date(blog.created_at).toDateString() : ""}</span>
                  <h4>{blog.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ===== FAQ ===== */}
        <section className="medicare-section container">
          <div className="medicare-box">
            <div className="medicare-left">
              <h2>Kamagra Star</h2>
              <p>Kamagra Star is an online pharmacy offering affordable, high-quality medicines manufactured in GMP-compliant, FDA-approved facilities ensuring safety and trust.</p>
              <p>Our mission is to make healthcare simple, secure, and accessible for everyone.</p>
            </div>
            <div className="faq">
              {[
                { title: "100% Genuine Products", content: "We ensure our customers can blindly trust the products we offer. All medicines (branded or generics) are sourced from GMP-certified and FDA-compliant facilities. We supply genuine, high-quality medicines that follow strict regulatory checks before being sold." },

                { title: "Safe & Secure Packing", content: "We ensure every single order is packaged in factory-sealed blister/strip packaging.Additionally, all orders are shipped in plain, confidential packaging to protect privacy, even from delivery agents. There are no labels or markings on the outside that indicate the contents, ensuring complete privacy." },

                { title: "Super Fast Delivery", content: "We are committed to providing reliable and secure delivery of your medicines worldwide. Before placing an order, please review your local regulations regarding the import of medicines from international pharmacies." },

                { title: "24/7 Customer Support", content: "Our support team is always available to help you anytime you need assistance." },

                { title: "Privacy Assured", content: "We use SSL encryption and secure cloud infrastructure to ensure all details provided are encrypted. We don't sell our customers’ information in any form to any third party." }
                
              ].map((item, index) => (
                <FAQItem
                  key={index}
                  title={item.title}
                  content={item.content}
                  isOpen={activeFAQ === index}
                  onClick={() => setActiveFAQ(activeFAQ === index ? null : index)}
                />
              ))}
            </div>
          </div>
        </section>

        {/* ===== BANNERS — NEW DESIGN ===== */}
        <section className="banners container">
          <div className="banner banner-purple">
            <div className="banner-tag">Limited Offer</div>
            <h3>Flat 25% Off</h3>
            <p>On all vitamins & supplements</p>
            <button className="btn banner-btn-light" onClick={() => navigate("/categories/sildenafil-citrate")}>Shop Now →</button>
          </div>
          <div className="banner banner-teal">
            <div className="banner-tag">Free With Order</div>
            <h3>Free Health Checkup</h3>
            <p>With orders above €50</p>
            <button className="btn banner-btn-light" onClick={() => navigate("/categories/kamagra")}>Learn More →</button>
          </div>
        </section>

        {/* ===== TESTIMONIALS ===== */}
        <section className="testimonials container">
          <h2 className="section-title">What Our Customers Say</h2>
          <div className="test-grid">
            <div className="test-card">
              <div className="stars">★★★★★</div>
              <p>"Fast shipping and genuine products. Highly recommended!"</p>
              <h4>James Wilson</h4>
            </div>
            <div className="test-card">
              <div className="stars">★★★★★</div>
              <p>"Great service and excellent customer support."</p>
              <h4>Sophie Müller</h4>
            </div>
            <div className="test-card">
              <div className="stars">★★★★★</div>
              <p>"Affordable prices with discreet packaging."</p>
              <h4>Marco Rossi</h4>
            </div>
          </div>
        </section>

        {/* ===== NEWSLETTER ===== */}
        <section className="newsletter-section container">
          <div className="newsletter-box">
            <h2 className="newsletter-title">Sign Up & Don't Miss Any Updates</h2>
            <p className="newsletter-subtitle">Get curated health tips & exclusive deals right in your inbox.</p>
            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <label htmlFor="newsletter">Sign Up for Our Newsletter:</label>
              <div className="newsletter-input-box">
                <input
                  type="email"
                  id="newsletter"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button className="btn" type="submit">Subscribe</button>
              </div>
            </form>
          </div>
        </section>

      </div>
    </>
  );
}

function FAQItem({ title, content, isOpen, onClick }) {
  return (
    <div className={`faq-item ${isOpen ? "active" : ""}`}>
      <div className="faq-question" onClick={onClick}>
        <h4>{title}</h4>
        <span className={`arrow ${isOpen ? "rotate" : ""}`}>⌄</span>
      </div>
      <div className={`faq-answer ${isOpen ? "show" : ""}`}>
        <p>{content}</p>
      </div>
    </div>
  );
}

export default Home;